import { render, staticRenderFns } from "./WeightChart.vue?vue&type=template&id=65592ba6&scoped=true"
import script from "./WeightChart.vue?vue&type=script&lang=js"
export * from "./WeightChart.vue?vue&type=script&lang=js"
import style0 from "./WeightChart.vue?vue&type=style&index=0&id=65592ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65592ba6",
  null
  
)

export default component.exports